import { isTrackedPageRoute, type PageVisitRequest } from '@wundo/shared/pageVisit.ts';
import { apiFetch, isTransientFailure } from '@wundo/client/api.ts';
import { reportError } from './reportError.ts';

/**
 * Report that the signed-in user landed on a page, by its route pattern so
 * one meeting counts as the same page as any other. Fire and forget: the
 * page never waits for it.
 */
export function reportPageVisit(route: string): void {
  if (!isTrackedPageRoute(route)) return;

  void sendPageVisit({ route });
}

/* A lost count is not worth bothering the visitor with; only real failures reach Sentry. */
async function sendPageVisit(visit: PageVisitRequest): Promise<void> {
  try {
    await apiFetch('/page-visits', {
      method: 'POST',
      body: JSON.stringify(visit),
    });
  } catch (caught) {
    if (isTransientFailure(caught)) return;

    reportError(caught, { action: 'reportPageVisit', route: visit.route });
  }
}
